import React, { useContext } from 'react';
import Socials from './Socials';
import MobileNav from './MobileNav';
import Logo from '../img/header/logo2.png';
import { Link } from 'react-router-dom'
import { CursorContext } from '../context/CursorContext';

const Header = () => {

  const {mouseEnterHandler, mouseLeaveHandler} = useContext(CursorContext)

  return <header className='fixed w-full px-[30px] lg:px-[100px] z-30 h-[100px] lg:h-[140px] flex items-center'>
    <div className='flex flex-col lg:flex-row lg:items-center w-full justify-between'>
      <Link onMouseEnter={mouseEnterHandler} onMouseLeave={mouseLeaveHandler} to={'/'} className='max-w-[200px]'>
        <img src={Logo} alt='Logo' />
      </Link>

      <nav className='hidden xl:flex gap-x-12 font-semibold font-secondary' onMouseEnter={mouseEnterHandler} onMouseLeave={mouseLeaveHandler}>
        <Link  to={'/'} className='nav-link font-medium'>Home</Link>
        <Link to={'/contact'} className='nav-link font-medium'>Contact</Link>
        <Link to={'/portfolio'} className='nav-link font-medium'>Portfolio</Link>
        <Link to={'/about'} className='nav-link font-medium'>About</Link>
      </nav>
    </div>
    
    <Socials />

    <MobileNav />
  </header>;
};

export default Header;
